import { MapTo } from '@adobe/aem-react-editable-components';
import Disclaimer, { DisclaimerEditConfig } from './Disclaimer';

export default MapTo(
    'cob-corp-acquisition/components/creditonebank/disclaimer',
)(Disclaimer, DisclaimerEditConfig);